import { render, staticRenderFns } from "./TestbankQuestionList.vue?vue&type=template&id=2e6f1924&"
import script from "./TestbankQuestionList.vue?vue&type=script&lang=js&"
export * from "./TestbankQuestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6f1924')) {
      api.createRecord('2e6f1924', component.options)
    } else {
      api.reload('2e6f1924', component.options)
    }
    module.hot.accept("./TestbankQuestionList.vue?vue&type=template&id=2e6f1924&", function () {
      api.rerender('2e6f1924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Question/TestbankQuestionList.vue"
export default component.exports